import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { UsersService } from './users.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class UsersServiceModule {
  static forRoot(): ModuleWithProviders<UsersServiceModule> {
    return {
      ngModule: UsersServiceModule,
      providers: [UsersService],
    };
  }
}
